import { render, staticRenderFns } from "./ElementFactSelfTableColumn.vue?vue&type=template&id=77fc797a"
import script from "./ElementFactSelfTableColumn.vue?vue&type=script&lang=js"
export * from "./ElementFactSelfTableColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports